import VerofreshRecord from './VerofreshRecord'
import Moment from 'moment'

class VehicleStateRecord extends VerofreshRecord {
  /**
   * returns the unix time representation of the record's timestamp
   */
  get unixtime () {
    return new Moment(this.timestamp).unix()
  }

  /**
   * Returns a comma separated string of latitude and longitude (e.g.
   * 32.123445,-113.987654)
   *
   * @return string|undefined
   */
  getGpsCoordinatesAsString () {
    if (this.lat && this.long) {
      return `${this.lat.toFixed(6)},${this.long.toFixed(6)}`
    }
    return undefined
  }
}

export default VehicleStateRecord
